import { Validation } from 'utils/Validation';

const RegisterForm = {

    rules: {
        name: { required: true, type: 'string', minLength: 4, maxLegth: 40, displayName: "Name" },
        accountName: { required: false, type: 'string', minLength: 4, maxLegth: 60, displayName: "Account Name" },
        email: { required: true, type: 'string', minLength: 6, maxLegth: 40, regex: Validation.EMAIL_REGEX, displayName: "Email" },
        password: { required: true, type: 'string', minLength: 6, maxLegth: 20, displayName: "Password" },
        //confirmPassword: { required: true, type: 'string', minLength: 6, maxLegth: 20, mustMatch: 'password', displayName: "Confirmation" }
    }

}

export default RegisterForm;
